import { styled } from '@mui/material/styles';

export const PageContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  flex: 1,
  padding: theme.spacing(4, 6, 4, 6),
}));
